export default __webpack_public_path__ + "static/Free-38a02319ea826aaf6d55199e28039a15.png";